import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import Menu from '../../components/sturtural/Menu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom'
import { TabView, TabPanel } from 'primereact/tabview';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { storage } from '../../helpers/storage';

const estatues = [
    { label: 'Todos', value: 1 },
    { label: 'Pendientes', value: 2 },
    { label: 'Entregado completo', value: 4 },
    { label: 'Entregado parcial', value: 3 },
]

const ReporteGeneral = () => {
    const navigate = useNavigate();

    const [regioneles, setRegiones] = useState(null);
    const [municipios, setMunicipios] = useState(null);
    const [loading_tiendas, setLoading_tiendas] = useState(false)
    const [loading_resgionales, setLoading_regionales] = useState(false);
    const [loading_municipios, setLoading_municipios] = useState(false);
    const [error_regionales, setErrors_regionales] = useState(false);
    const [error_municipios, setErrors_municipios] = useState(false);
    const [error_tiendass, setErrors_tiendas] = useState(false);
    const [regional, setRegional] = useState(-1);
    const [municipio, setMunicipio] = useState(-1);
    const [tiendas, setTiendas] = useState(null);
    const [tienda, setTienda] = useState();
    const [estatus, setEstatus] = useState(estatues[0].value);
    const [ct, setCT] = useState('')

    const [niveles, setNiveles] = useState(null);
    const [loading_niveles, setLoading_niveles] = useState(false);
    const [error_niveles, setErrors_niveles] = useState(false);
    const [nivel, setNivel] = useState(-1);

    const [calendarValueInicio, setCalendarValueInicio] = useState(null);
    const [calendarValueFin, setCalendarValueFin] = useState(null);

    const [clave, setClave] = useState();

    const [loading, setLoading] = useState(false);

    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);

    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo')

    useEffect(() => {
        if (![1, 3, 4, 5, 16, 17, 19, 20, 21].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        if (activeIndex === 0) {
            let url = `${BASE_API}Entrega/GetObtenerGrupoTiendas`;
            setLoading_tiendas(true);
            helpHttp().get(url, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                let response = res;
                if (response.SUCCESS === true) {
                    setTiendas(response.ITEMS);
                    setErrors_tiendas(false);
                } else {
                    setTiendas(null);
                    setErrors_tiendas('Error en la extracción de datos de REGIONALES');
                }
                setLoading_tiendas(false);
            });
        }
    }, [activeIndex]);

    useEffect(() => {
        if (activeIndex === 1) {
            let url = `${BASE_API}BusquedaAlumnos/GetRptDelReg`;

            setLoading_regionales(true);
            helpHttp().get(url, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                let response = res.ITEMS;
                if (response.SUCCESS === true) {
                    setRegiones(response.ITEMS);
                    setErrors_regionales(false);
                } else {
                    setRegiones(null);
                    setErrors_regionales('Error en la extracción de datos de REGIONALES');
                }
                setLoading_regionales(false);
            });
        }
    }, [activeIndex]);

    useEffect(() => {
        if (activeIndex === 2 || activeIndex === 4) {
            let url = `${BASE_API}Escuela/CargarMunicipios`;

            setLoading_municipios(true);
            helpHttp().post(url, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                let response = res;
                // console.log(response)
                // if (response.SUCCESS === true) {
                const todos = { IdMunicipio: 0, Municipio: 'Todos' }
                response.unshift(todos);
                setMunicipios(response);
                setErrors_municipios(false);
                // } else {
                //     setMunicipios(null);
                //     setErrors_municipios('Error en la extracción de datos de REGIONALES');
                // }
                setLoading_municipios(false);
            });
        }
    }, [activeIndex]);

    useEffect(() => {
        if (activeIndex === 1 || activeIndex === 2) {
            let url1 = `${BASE_API}BusquedaAlumnos/GetRptNivel`;
            setLoading_niveles(true);
            helpHttp().get(url1, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                let response = res.ITEMS;
                if (response.SUCCESS === true) {
                    setNiveles(response.ITEMS);
                    setErrors_niveles(false);
                } else {
                    setNiveles(null);
                    setErrors_niveles('Error en la extracción de datos de NIVELES');
                }
                setLoading_niveles(false);
            });
        }
    }, [activeIndex]);

    const handleSubmit_busquedaMuncicipio = () => {
        if (municipio !== -1) {
            setLoading(true);

            helpHttp().post(`${BASE_API}BusquedaAlumnos/SpdRptPendientesMunicipio`, {
                body: {
                    code: municipio.IdMunicipio,
                    parametroExtras: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`,
                    IdCicloEscolar: ciclo.IdCicloEscolar
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    let excel = res.ITEMS;
                    const date = new Date()

                    let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                    let download = document.createElement('a');
                    download.href = temp;
                    download.download = `Pendientes_${municipio.Municipio}_Ciclo_${ciclo.Descripcion}_${date.toLocaleDateString('en-GB')}.xlsx`;
                    document.body.appendChild(download);
                    download.click();
                    document.body.removeChild(download);

                    setLoading(false);
                } else {
                    setMessage(res.MESSAGE);
                    setAviso(true);

                    setLoading(false);
                }
            })
        } else {
            setMessage("Debe seleccionar el municipio.");
            setAviso(true);
        }
    }

    const handleSubmit_obtenerReportePendientes = () => {
        if (municipio !== -1) {
            setLoading(true);

            helpHttp().post(`${BASE_API}Reportes/spdReportes`, {
                body: {
                    opcion: 1,
                    ParametrosExtra: `[{
                        "IdCicloEscolar": ${ciclo.IdCicloEscolar},
                        "IdMunicipio": ${municipio.IdMunicipio}
                    }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    let excel = res.ITEMS;
                    const date = new Date()

                    let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                    let download = document.createElement('a');
                    download.href = temp;
                    download.download = `Pendientes_${municipio.Municipio}_Ciclo_${ciclo.Descripcion}_${date.toLocaleDateString('en-GB')}.xlsx`;
                    document.body.appendChild(download);
                    download.click();
                    document.body.removeChild(download);

                    setLoading(false);
                } else {
                    setMessage(res.MESSAGE);
                    setAviso(true);

                    setLoading(false);
                }
            })
        } else {
            setMessage("Debe seleccionar el municipio.");
            setAviso(true);
        }
    }

    const handleSubmit_busqueda = () => {

        if ((nivel.code != null || nivel.code != undefined) && (regional.code != null || regional.code != undefined) || (clave != null || clave != undefined)) {

            let body = {
                "IdNivel": (nivel.code === null || nivel.code === undefined ? -1 : nivel.code),
                "IdDelRegional": (regional.code === null || regional.code === undefined ? -1 : regional.code),
                "Estatus": -1,
                "IdEscuela": (clave === null || clave === undefined ? '-' : clave),
                "Fecha": '1900',
                "FechaFin": "",
                "Tienda": -1,
                "IdCicloEscolar": ciclo.IdCicloEscolar
            };

            setLoading(true);
            helpHttp().post(`${BASE_API}BusquedaAlumnos/GetRptExcelAlumnos`, {
                body: body,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                if (res.ITEMS.SUCCESS) {
                    let excel = res.ITEMS.ITEMS;

                    let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                    let download = document.createElement('a');
                    download.href = temp;
                    download.download = `ReporteGeneralExcel_Ciclo_${ciclo.Descripcion}.xlsx`;
                    document.body.appendChild(download);
                    download.click();
                    document.body.removeChild(download);

                    setLoading(false);
                } else {
                    setMessage(res.ITEMS.MESSAGE);
                    setAviso(true);

                    setLoading(false);
                }
            });
        } else {
            setMessage("Debe seleccionar la regional y el nivel.");
            setAviso(true);
        }
    }

    const handleSubmit_busquedaGeneral = () => {

        if (tienda !== undefined) {
            let body = {
                "Tienda": tienda.code,
                "Estatus": 2,
                "IdEscuela": '-',
                "IdNivel": -1,
                "IdDelRegional": -1,
                "Fecha": (calendarValueInicio === null || calendarValueInicio === undefined ? '1900' : calendarValueInicio),
                "FechaFin": (calendarValueFin === null || calendarValueFin === undefined ? "" : calendarValueFin),
                "IdCicloEscolar": ciclo.IdCicloEscolar
            };
            setLoading(true);
            helpHttp().post(`${BASE_API}BusquedaAlumnos/GetRptExcelAlumnos`, {
                body: body,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                if (res.SUCCESS) {
                    let excel = res.ITEMS.ITEMS;

                    let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                    let download = document.createElement('a');
                    download.href = temp;
                    download.download = `ReporteCorteAdministrador_Ciclo_${ciclo.Descripcion}.xlsx`;
                    document.body.appendChild(download);
                    download.click();
                    document.body.removeChild(download);

                    setLoading(false);
                } else {
                    setMessage(res.ITEMS.MESSAGE);
                    setAviso(true);

                    setLoading(false);
                }
            });
        } else {
            setMessage('Debe seleccionar una tienda');
            setAviso(true);
        }

    }

    const handleSubmit_busquedaCT = () => {
        setLoading(true);

        if (ct !== '') {
            const arrConsulta = {
                Opcion: estatus,
                ct: ct,
                IdNivel: 0,
                IdTurno: 0,
                Grado: "",
                Grupo: "",
                parametroExtras: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`
            }
            console.log(arrConsulta)
            helpHttp().post(`${BASE_API}Entrega/postSpdRptPendientesCT`, {
                body: arrConsulta,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS === true) {
                    const date = new Date()
                    const linkSource = `data:application/vnd.ms-excel;base64,${res.ITEMS}`;
                    const downloadLink = document.createElement('a');
                    const fileName = `Reporte_${ct}_${estatues.find(x => x.value === estatus).label}_Ciclo_${ciclo.Descripcion}_${date.toLocaleDateString('en-GB')}.xlsx`

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
                setLoading(false);
            })
        }
    }

    const handlerRedirect = () => {
        setAviso(false);
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <Menu link='reporte-general' />
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                <TabPanel header='Sede'>
                    <div className="grid">
                        <div className="col-12">
                            <div>
                                <h3>Reporte general de sede</h3>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="regional">{loading_tiendas && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Sede:</label>
                                        {error_tiendass !== false
                                            ?
                                            error_tiendass
                                            :
                                            <Dropdown id="tienda" name="tienda" value={tienda} filter options={tiendas} onChange={(e) => setTienda(e.target.value)} optionLabel="name" placeholder="Elige una sede" emptyMessage='No se encontró información' className=""></Dropdown>
                                        }

                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="regional">Fecha inicio:</label>
                                        <Calendar locale='es' dateFormat='dd/mm/yy' showIcon showButtonBar value={calendarValueInicio} onChange={(e) => setCalendarValueInicio(e.value)}></Calendar>
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="nivel">Fecha fin:</label>
                                        <Calendar dateFormat='dd/mm/yy' locale='es' showIcon showButtonBar value={calendarValueFin} onChange={(e) => setCalendarValueFin(e.value)}></Calendar>
                                    </div>
                                </div>
                                <div className="p-dialog-footer">
                                    <div className=" border-top-1 surface-border pt-3 text-right">
                                        <Button
                                            type='button'
                                            name="button-generar"
                                            id="button-generar"
                                            disabled={loading}
                                            icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')}
                                            label="Generar"
                                            onClick={() => handleSubmit_busquedaGeneral()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header='Regionales'>
                    <div className="grid">
                        <div className="col-12">
                            <div>
                                <h3>Reporte general regionales</h3>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="regional">{loading_resgionales && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Regionales:</label>
                                        {error_regionales !== false
                                            ?
                                            error_regionales
                                            :
                                            <Dropdown id="regional" name="regional" value={regional} options={regioneles} onChange={(e) => setRegional(e.target.value)} optionLabel="name" placeholder="Elige una regional" emptyMessage='No se encontró información' className=""></Dropdown>
                                        }

                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="nivel">{loading_niveles && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Niveles:</label>
                                        {error_niveles !== false
                                            ?
                                            error_niveles
                                            :
                                            <Dropdown id="nivel" name="nivel" value={nivel} options={niveles} optionLabel="name" onChange={(e) => setNivel(e.target.value)} placeholder="Elige un nivel" emptyMessage='No se encontró información' className=""></Dropdown>
                                        }
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="clave">Clave CT:</label>
                                        <InputText id="clave" name="clave" type="text" value={clave} onChange={(e) => setClave(e.target.value)} />
                                    </div>
                                </div>
                                <div className="p-dialog-footer">
                                    <div className=" border-top-1 surface-border pt-3 text-right">
                                        <Button type='button' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')} label="Generar" onClick={() => handleSubmit_busqueda()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header='Municipio'>
                    <div className="grid">
                        <div className="col-12">
                            <div>
                                <h3>Reporte general municipios (Por entregar)</h3>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="municipio">{loading_municipios && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Municipios:</label>
                                        {error_municipios !== false
                                            ?
                                            error_municipios
                                            :
                                            <Dropdown id="municipio" name="municipio" value={municipio} options={municipios} onChange={(e) => setMunicipio(e.target.value)} optionLabel="Municipio" placeholder="Elige un municipio" emptyMessage='No se encontró información' className="" filter />
                                        }

                                    </div>
                                </div>
                                <div className="p-dialog-footer">
                                    <div className=" border-top-1 surface-border pt-3 text-right">
                                        <Button type='button' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')} label="Generar" onClick={() => handleSubmit_busquedaMuncicipio()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header='CT'>
                    <div className="grid">
                        <div className="col-12">
                            <div>
                                <h3>Reporte general de centros de trabajo</h3>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="ct">Clave CT:</label>
                                        <InputText id="ct" name="ct" value={ct} onChange={(e) => setCT(e.target.value)} optionLabel="Municipio" placeholder="Elige un Centro de Trabajo" />

                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="estatus">Estatus:</label>
                                        <Dropdown id="estatus" name="estatus" value={estatus} options={estatues} onChange={(e) => setEstatus(e.target.value)} optionLabel="label" optionValue='value' placeholder="Elige un estatus" />

                                    </div>
                                </div>
                                <div className="p-dialog-footer">
                                    <div className=" border-top-1 surface-border pt-3 text-right">
                                        <Button type='button' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')} label="Generar" onClick={() => handleSubmit_busquedaCT()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header='Pendientes'>
                    <div className="grid">
                        <div className="col-12">
                            <div>
                                <h3>Reporte de CTs (lista de pendientes)</h3>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="municipio">{loading_municipios && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Municipios:</label>
                                        {error_municipios !== false
                                            ?
                                            error_municipios
                                            :
                                            <Dropdown id="municipio" name="municipio" value={municipio} options={municipios} onChange={(e) => setMunicipio(e.target.value)} optionLabel="Municipio" placeholder="Elige un municipio" emptyMessage='No se encontró información' className="" filter />
                                        }

                                    </div>
                                </div>
                                <div className="p-dialog-footer">
                                    <div className=" border-top-1 surface-border pt-3 text-right">
                                        <Button type='button' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')} label="Generar" onClick={() => handleSubmit_obtenerReportePendientes()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </TabView>

            <Dialog header="Aviso" visible={aviso} onHide={() => setMessage(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default ReporteGeneral;